//bar
import barClusteredBarChart from "assets/images/chart-images/clustered-bar-chart.png";

const sectionCategory = [
    { id: "TDILTPSC-BVS01e", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false, description: "AVERAGE" },
];

export default sectionCategory;